import { render, staticRenderFns } from "./AccountFormSecurity.vue?vue&type=template&id=37268086&scoped=true&"
import script from "./AccountFormSecurity.vue?vue&type=script&lang=js&"
export * from "./AccountFormSecurity.vue?vue&type=script&lang=js&"
import style0 from "./AccountFormSecurity.vue?vue&type=style&index=0&id=37268086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37268086",
  null
  
)

export default component.exports